import React from "react";

import numeral from "numeral";

import Select from "react-select";

import RightPanel from "components/Monitoring/RightPanel";
import MainGraph from "components/Monitoring/MainGraph";
import CountsGraph from "components/Monitoring/CountsGraph";
import BarGraphs from "components/Monitoring/BarGraphs";
import NextSubgroups from "components/Monitoring/NextSubgroups";
import AlertCard from "components/Monitoring/AlertCard";
import DataDriftAlertCard from "components/Monitoring/DataDriftAlertCard";
import FairnessAlertCard from "components/Monitoring/FairnessAlertCard";
import UserFeedback from "containers/Monitoring/UserFeedback";
import UserTargeting from "containers/Monitoring/UserTargeting";
import RetrainFrontiers from "components/Monitoring/RetrainFrontiers";
import DataEvaluation from "components/Monitoring/DataEvaluation";
import PieChart from "components/Project/PieChart";
import FunnelTooltip from "components/Business/ModelBox/FunnelTooltip";

import ComplianceGraphContainer from "containers/Monitoring/ComplianceGraph";
import DataDriftContainer from "containers/Monitoring/DataDrift";

import FairnessResultsContainer from "containers/Monitoring/FairnessResults";

import ImpliedStrategy from "containers/UnifiedProject/RealityCheck/ImpliedStrategy";
import MiniModelBoxContainer from "containers/Business/ModelBox/MiniModelBox";
import { SUBGROUP_DATA, OVERALL_DATA } from "components/Monitoring/RetrainFrontiers";
import { FAIRNESS_OBJECTIVE } from "containers/Project/reducer";

import NotificationBell from "images/Next-Icons/NotificationBell.svg";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { isEnabled } from "utils/featureFlags";

import { ALERT_TYPES, MONITOR_VIEW_MODES, NEXT_VIEW_MODES_LIST } from "containers/Monitoring/reducer";
import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

import styles from "./style.module.css";
import { ButtonGroup, Button, Accordion } from "aible";

export default class NextMonitoring extends React.Component {
  state = {
    selectedRetrain: undefined,
    ignored: {},
    viewMode: ""
  };

  handleClose() {
    return this.setState({ selectedRetrain: undefined });
  }

  handleRetrain(label, count) {
    return this.setState({
      selectedRetrain: {
        label,
        count
      }
    });
  }

  handleUpdateIgnored(value, isIgnored) {
    return this.setState({
      ...this.state.ignored,
      [value]: isIgnored ? true : undefined
    });
  }

  renderMonitoring() {
    const {
      id,
      segmentId,
      warnings,
      adjustAssumptions,
      monitoringData,
      latestData,
      latestScenario,
      scenarioIndex,
      isContinuous,
      monitorViewMode,
      updateMonitorViewMode,
      userFeedback,
      deleteUserFeedback,
      selectedDataset,
      compliancePlot,
      timePeriod,
      setupLabels,
      isLoading,
      targetValue,
      targetValueOptions,
      updateTargetValue,
      graphMode,
      graphModeOptions,
      updateGraphMode,
      businessPredictionName
    } = this.props;

    if (isLoading) {
      return (
        <div className={styles.monitoringWrapper}>
          <div className={styles.monitoringBody + " " + styles.monitoringError}>
            <div className={styles.monitoringErrorTitle}>{"Loading Monitoring Data..."}</div>
            <div className={styles.monitoringErrorBody}>
              <LoadingIndicator />
            </div>
          </div>
        </div>
      );
    }

    if (
      !(
        monitoringData &&
        monitoringData[segmentId] &&
        monitoringData[segmentId].data &&
        monitoringData[segmentId].data.length
      )
    ) {
      return (
        <div className={styles.monitoringWrapper}>
          <div className={styles.monitoringBody + " " + styles.monitoringError}>
            <div className={styles.monitoringErrorTitle}>{"No Monitoring Data Found"}</div>
            <div className={styles.monitoringErrorBody}>{"There is no monitoring data for this subgroup."}</div>
            <div className={styles.monitoringErrorBody}>
              {
                "Monitoring data is updated every 24 hours, so please check back later if you have recently made changes."
              }
            </div>
          </div>
        </div>
      );
    }

    const label = latestData && latestData[segmentId] && latestData[segmentId].label;
    const segmentWarnings = warnings && warnings[segmentId];
    const latestSegmentScenarios = latestScenario && latestScenario[segmentId];
    const segmentScenarios = monitoringData && monitoringData[segmentId] && monitoringData[segmentId].scenarios;

    const hasCompliancePlot = isEnabled("user-compliance");
    const showMenu = hasCompliancePlot;
    return (
      <div className={styles.monitoringWrapper}>
        <div className={styles.monitoringBody}>
          {showMenu && (
            <ButtonGroup style={{ margin: "10px 10px 20px" }}>
              <Button
                onClick={() => updateMonitorViewMode(MONITOR_VIEW_MODES.IMPACT)}
                active={monitorViewMode === MONITOR_VIEW_MODES.IMPACT}
              >
                {setupLabels[targetValue + "Label"]}
              </Button>
              {/* <Button
              onClick={() => updateMonitorViewMode(MONITOR_VIEW_MODES.DATA_EVALUATION)}
              active={monitorViewMode === MONITOR_VIEW_MODES.DATA_EVALUATION}
            >
              {"Data Evaluation"}
            </Button> */}
              <Button
                onClick={() => updateMonitorViewMode(MONITOR_VIEW_MODES.USER_BEHAVIOR)}
                active={monitorViewMode === MONITOR_VIEW_MODES.USER_BEHAVIOR}
              >
                {"User Analytics"}
              </Button>
            </ButtonGroup>
          )}
          {getIsMonitoringDemo() ? (
            <RetrainFrontiers
              isOpen={this.state.selectedRetrain !== undefined}
              data={this.state.selectedRetrain}
              handleClose={() => this.handleClose()}
              updateIgnored={(value, isIgnored) => this.handleUpdateIgnored(value, isIgnored)}
              ignored={this.state.ignored}
              selectedDataset={selectedDataset}
            />
          ) : (
            ""
          )}
          {monitorViewMode === MONITOR_VIEW_MODES.IMPACT ? (
            <React.Fragment>
              <MainGraph
                latestScenarios={latestSegmentScenarios}
                scenarios={segmentScenarios}
                label={label}
                scenarioIndex={scenarioIndex}
                isContinuous={isContinuous}
                setupLabels={setupLabels}
                targetValue={targetValue}
                targetValueOptions={targetValueOptions}
                updateTargetValue={updateTargetValue}
                graphMode={graphMode}
                graphModeOptions={graphModeOptions}
                updateGraphMode={updateGraphMode}
              />
              <BarGraphs
                adjustAssumptions={() => adjustAssumptions()}
                data={latestData && latestData[segmentId]}
                isContinuous={isContinuous}
                timePeriod={timePeriod}
                setupLabels={setupLabels}
              />
              <NextSubgroups
                data={monitoringData}
                isContinuous={isContinuous}
                handleRetrain={getIsMonitoringDemo() ? (label, count) => this.handleRetrain(label, count) : undefined}
                setupLabels={setupLabels}
                graphMode={graphMode}
                targetValue={targetValue}
                targetValueOptions={targetValueOptions}
              />
            </React.Fragment>
          ) : monitorViewMode === MONITOR_VIEW_MODES.USER_BEHAVIOR ? (
            <React.Fragment>
              <ComplianceGraphContainer id={id} />
              <UserFeedback id={id} compliancePlot={compliancePlot} />
            </React.Fragment>
          ) : monitorViewMode === MONITOR_VIEW_MODES.DATA_EVALUATION ? (
            <React.Fragment>
              <DataEvaluation
                monitoringData={monitoringData && monitoringData[segmentId] && monitoringData[segmentId].data}
              />
            </React.Fragment>
          ) : monitorViewMode === MONITOR_VIEW_MODES.USER_COMPLIANCE ? (
            <React.Fragment>
              <ComplianceGraphContainer id={id} />
            </React.Fragment>
          ) : monitorViewMode === MONITOR_VIEW_MODES.FAIRNESS ? (
            <FairnessResultsContainer id={id} />
          ) : monitorViewMode === MONITOR_VIEW_MODES.TARGETING ? (
            <UserTargeting id={id} />
          ) : (
            <React.Fragment />
          )}
        </div>
        {/* <RightPanel
          isOpen={Boolean(segmentWarnings && segmentWarnings.length)}
          title={"Performance Alerts"}
        >
          {segmentWarnings &&
            segmentWarnings.map((warning, i) => (
              <AlertCard
                key={"alert-" + i}
                data={warning}
                adjustAssumptions={adjustAssumptions}
                timePeriod={timePeriod}
                setupLabels={setupLabels}
              />
            ))}
        </RightPanel> */}
      </div>
    );
  }

  renderTopSummary() {
    const { optimized, modelGroups, monitoringData, segmentId, setupLabels, monitorViewMode, updateMonitorViewMode } =
      this.props;
    if (
      !(
        monitoringData &&
        monitoringData[segmentId] &&
        monitoringData[segmentId].data &&
        monitoringData[segmentId].data.length
      )
    ) {
      return;
    }
    const renderPieSection = () => {
      const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];
      const segments = drilldownValues.filter((segment) => segment.label !== "Overall");
      const units = optimized && optimized.unitLabelShort ? optimized.unitLabelShort : "";
      const pieData = segments
        ? segments.map((s) => ({
            name: s.value,
            runId: s.runId,
            value: Math.round(Math.abs(s["currentSpend"])),
            color: s.color + "50"
          }))
        : [];

      const optimizedPieData = segments
        ? segments.map((s) => ({
            name: s.value,
            runId: s.runId,
            value: Math.round(Math.abs(s["totalCost"])),
            color: s.color
          }))
        : [];

      const pieValuesSum =
        pieData && pieData.length > 0 && pieData.map((segment) => segment.value).reduce((a, b) => a + b);
      return (
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            borderRight: "1px solid #C8CAD4",
            height: "125px",
            minWidth: "20%"
          }}
        >
          <div className={styles.overviewHeader}>Resourcing Mix</div>
          <div style={{ display: "flex", flex: "1 1 auto" }}>
            <div className={styles.overviewNumbersSubsection}>
              <div style={{ flex: "1 1 auto" }}>
                <PieChart showSegments pData={pieData} unit={units} hideLegend hideTooltip isSmall />
              </div>
              <div style={{ textAlign: "center", color: "#868595" }}>Planned</div>
            </div>
            <div className={styles.overviewNumbersSubsection}>
              <div style={{ flex: "1 1 auto" }}>
                <PieChart showSegments pData={optimizedPieData} unit={units} hideLegend hideTooltip isSmall />
              </div>
              <div style={{ textAlign: "center" }}>Actual</div>
            </div>
          </div>
        </div>
      );
    };

    const segmentScenarios = monitoringData && monitoringData[segmentId] && monitoringData[segmentId].scenarios;

    const cumulativeData = {
      cost: 0,
      costAssumed: 0,
      profit: 0,
      profitAssumed: 0,
      revenue: 0,
      revenueAssumed: 0
    };

    segmentScenarios.forEach((datapoint) => {
      const data = datapoint.bestScenario ? datapoint.bestScenario : datapoint.selectedScenario;
      if (!data) {
        return;
      }
      cumulativeData.cost += data.cost;
      cumulativeData.costAssumed += data.costAssumed;
      cumulativeData.profit += data.profit;
      cumulativeData.profitAssumed += data.profitAssumed;
      cumulativeData.revenue += data.revenue;
      cumulativeData.revenueAssumed += data.revenueAssumed;
    });

    const showSummary =
      monitorViewMode !== MONITOR_VIEW_MODES.FAIRNESS &&
      monitorViewMode !== MONITOR_VIEW_MODES.TARGETING &&
      monitorViewMode !== MONITOR_VIEW_MODES.DATA_DRIFT;

    return (
      <React.Fragment>
        <div
          style={{
            borderBottom: "1px solid #C8CAD4",
            width: "100%",
            padding: "10px 20px",
            fontWeight: "bold",
            fontSize: "18px"
          }}
        >
          <div style={{ maxWidth: "400px" }}>
            <Select
              value={NEXT_VIEW_MODES_LIST.find((elem) => elem.value === monitorViewMode)}
              onChange={(s) => updateMonitorViewMode(s.value)}
              options={NEXT_VIEW_MODES_LIST}
            />
          </div>
        </div>
        {showSummary ? (
          <div style={{ borderBottom: "1px solid #C8CAD4", display: "flex" }}>
            <div
              className={styles.overviewSection}
              style={{
                borderRight: "1px solid #C8CAD4"
              }}
            >
              <div className={styles.overviewHeader}>{setupLabels.costLabel}</div>
              <div className={styles.overviewNumbers}>
                <div className={styles.overviewNumeral}>
                  {/* {`${setupLabels.unitType}${numeral(Number(optimized.currentSpend)).format("0.0a")}`} */}
                  {`${setupLabels.unitType}${numeral(Number(cumulativeData.costAssumed)).format("0.0a")}`}
                  <div className={styles.numeralSubtext}>Planned</div>
                </div>
                <div className={styles.overviewNumeralRight}>
                  {/* {`${setupLabels.unitType}${numeral(Number(optimized.totalCost)).format("0.0a")}`} */}
                  {`${setupLabels.unitType}${numeral(Number(cumulativeData.cost)).format("0.0a")}`}
                  <div className={styles.numeralSubtext}>Actual</div>
                </div>
              </div>
            </div>
            {modelGroups?.drilldownValues && modelGroups.drilldownValues.length > 1 && renderPieSection()}
            <div
              className={styles.overviewSection}
              style={{
                borderRight: "1px solid #C8CAD4"
              }}
            >
              <div className={styles.overviewHeader}>{setupLabels.revenueLabel}</div>
              <div className={styles.overviewNumbers}>
                <div className={styles.overviewNumeral}>
                  {/* {`${setupLabels.unitType}${numeral(Number(optimized.currentRevenue)).format("0.0a")}`} */}
                  {`${setupLabels.unitType}${numeral(Number(cumulativeData.revenueAssumed)).format("0.0a")}`}
                  <div className={styles.numeralSubtext}>Planned</div>
                </div>
                <div className={styles.overviewNumeralRight}>
                  {/* {`${setupLabels.unitType}${numeral(Number(optimized.revenue)).format("0.0a")}`} */}
                  {`${setupLabels.unitType}${numeral(Number(cumulativeData.revenue)).format("0.0a")}`}
                  <div className={styles.numeralSubtext}>Actual</div>
                </div>
              </div>
            </div>
            <div className={styles.overviewSection}>
              <div className={styles.overviewHeader}>{setupLabels.profitLabel}</div>
              <div className={styles.overviewNumbers}>
                <div className={styles.overviewNumeral}>
                  {/* {`${setupLabels.unitType}${numeral(Number(optimized.currentProfit)).format("0.0a")}`} */}
                  {`${setupLabels.unitType}${numeral(Number(cumulativeData.profitAssumed)).format("0.0a")}`}
                  <div className={styles.numeralSubtext}>Planned</div>
                </div>
                <div className={styles.overviewNumeralRight}>
                  {/* {`${setupLabels.unitType}${numeral(Number(optimized.profit)).format("0.0a")}`} */}
                  {`${setupLabels.unitType}${numeral(Number(cumulativeData.profit)).format("0.0a")}`}
                  <div className={styles.numeralSubtext}>Actual</div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <React.Fragment />
        )}
      </React.Fragment>
    );
  }

  getNewValueCapped(oldValue, oldMax, cap) {
    return ((oldValue - 0) * (cap - 0)) / (oldMax - 0) + 0;
  }

  getNewValue(oldValue, oldMax) {
    const { isSmall, strategy } = this.props;

    const { overallOnly, isOverallSegment } = this.props;
    const retWidth = isSmall || strategy ? 300 : 130;
    return ((oldValue - 0) * (retWidth - 0)) / (oldMax - 0) + 0;
  }

  renderMiniFunnel() {
    const { id, monitoringData, segmentId, setupLabels } = this.props;
    if (
      !(
        monitoringData &&
        monitoringData[segmentId] &&
        monitoringData[segmentId].data &&
        monitoringData[segmentId].data.length
      )
    ) {
      return null;
    }

    return (
      <div className={styles.funnelSection}>
        <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>
          {`${setupLabels?.outcomeLabel} Behavior`}
        </div>
        <div>
          <MiniModelBoxContainer id={id} isNext isMonitoring data={monitoringData} segmentId={segmentId} />
        </div>
      </div>
    );
  }

  renderLoadingPlaceholder() {
    return (
      <div className={styles.monitoringWrapper}>
        <div className={styles.monitoringBody + " " + styles.monitoringError}>
          <div className={styles.monitoringErrorTitle}>{"Loading Monitoring Data..."}</div>
          <div className={styles.monitoringErrorBody}>
            <LoadingIndicator />
          </div>
        </div>
      </div>
    );
  }

  renderMainPanel() {
    const {
      id,
      segmentId,
      warnings,
      adjustAssumptions,
      monitoringData,
      latestData,
      latestScenario,
      scenarioIndex,
      isContinuous,
      monitorViewMode,
      updateMonitorViewMode,
      userFeedback,
      deleteUserFeedback,
      selectedDataset,
      compliancePlot,
      timePeriod,
      setupLabels,
      isLoading,
      targetValue,
      targetValueOptions,
      updateTargetValue,
      graphMode,
      graphModeOptions,
      updateGraphMode,
      runId,
      modelGroups
    } = this.props;
    const label = latestData && latestData[segmentId] && latestData[segmentId].label;
    const segmentWarnings = warnings && warnings[segmentId];
    const latestSegmentScenarios = latestScenario && latestScenario[segmentId];
    const segmentScenarios = monitoringData && monitoringData[segmentId] && monitoringData[segmentId].scenarios;
    if (
      !(
        monitoringData &&
        monitoringData[segmentId] &&
        monitoringData[segmentId].data &&
        monitoringData[segmentId].data.length
      )
    ) {
      return (
        <div className={styles.monitoringWrapper}>
          <div className={styles.monitoringBody + " " + styles.monitoringError}>
            <div className={styles.monitoringErrorTitle}>{"No Monitoring Data Found"}</div>
            <div className={styles.monitoringErrorBody}>{"There is no monitoring data for this subgroup."}</div>
            <div className={styles.monitoringErrorBody}>
              {
                "Monitoring data is updated every 24 hours, so please check back later if you have recently made changes."
              }
            </div>
          </div>
        </div>
      );
    }

    const hasCompliancePlot = isEnabled("user-compliance");
    const showMenu = hasCompliancePlot;

    if (monitorViewMode === MONITOR_VIEW_MODES.FAIRNESS) {
      return <FairnessResultsContainer id={id} />;
    }

    if (monitorViewMode === MONITOR_VIEW_MODES.TARGETING) {
      return <UserTargeting id={id} compliancePlot={compliancePlot} />;
    }

    if (monitorViewMode === MONITOR_VIEW_MODES.DATA_DRIFT) {
      return <DataDriftContainer id={id} />;
    }

    return (
      <div className={styles.nextMonitoringWrapper}>
        <div id="mainChartPanel" className={styles.mainChartPanel}>
          <MainGraph
            latestScenarios={latestSegmentScenarios}
            scenarios={segmentScenarios}
            label={label}
            scenarioIndex={scenarioIndex}
            isContinuous={isContinuous}
            setupLabels={setupLabels}
            targetValue={targetValue}
            targetValueOptions={targetValueOptions}
            updateTargetValue={updateTargetValue}
            graphMode={graphMode}
            graphModeOptions={graphModeOptions}
            updateGraphMode={updateGraphMode}
          />
        </div>
        <div id="secondaryPanels" className={styles.secondaryPanels}>
          {!isContinuous && (
            <div
              id="leftMiniPanel"
              className={styles.subPanel}
              style={{ flexFlow: "column", borderRight: "1px solid rgba(0, 0, 0, 0.2)" }}
            >
              <ComplianceGraphContainer id={id} isNext />
            </div>
          )}
          <div
            id="rightMiniPanel"
            className={styles.subPanel}
            style={{
              flexFlow: "column",
              maxWidth: isContinuous ? undefined : "calc(50% - 5px",
              borderRight: isContinuous ? "1px solid rgba(0, 0, 0, 0.2)" : undefined
            }}
          >
            <div className={styles.subgroupsTitle}>{"Transactions Monitored"}</div>
            <CountsGraph
              data={monitoringData}
              segmentId={segmentId}
              graphMode={graphMode}
              targetValue={targetValue}
              isContinuous={isContinuous}
            />
            <NextSubgroups
              data={monitoringData}
              isContinuous={isContinuous}
              handleRetrain={getIsMonitoringDemo() ? (label, count) => this.handleRetrain(label, count) : undefined}
              setupLabels={setupLabels}
              graphMode={graphMode}
              targetValue={targetValue}
              targetValueOptions={targetValueOptions}
            />
          </div>
        </div>
        {!isContinuous && (
          <React.Fragment>
            <div id="secondaryPanels" className={styles.secondaryPanels + " " + styles.topBorder}>
              <div
                id="leftMiniPanel-2"
                className={styles.subPanel}
                style={{ flexFlow: "column", borderRight: "1px solid rgba(0, 0, 0, 0.2)" }}
              >
                <UserFeedback id={id} compliancePlot={compliancePlot} modelGroups={modelGroups} isNext />
              </div>
              <div
                id="rightMiniPanel"
                className={styles.subPanel}
                style={{ flexFlow: "column", maxWidth: "calc(50% - 5px" }}
              >
                <FairnessResultsContainer id={id} isMini />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  render() {
    const {
      runId,
      optimized,
      warnings,
      adjustAssumptions,
      timePeriod,
      setupLabels,
      segmentId,
      isLoading,
      fairnessWarnings,
      fairnessObjective,
      fairnessToleranceBound,
      dataDriftWarnings,
      modelDriftWarnings,
      isContinuous
    } = this.props;
    const segmentWarnings = warnings && warnings[segmentId];
    const retFairnessWarnings =
      fairnessObjective !== FAIRNESS_OBJECTIVE.NONE && fairnessWarnings?.filter((w) => w?.warning);
    const numWarnings =
      (segmentWarnings && segmentWarnings.length ? segmentWarnings.length : 0) +
      (retFairnessWarnings?.length ? 1 : 0) +
      (dataDriftWarnings ? 1 : 0) +
      (modelDriftWarnings ? 1 : 0);
    return (
      <div className={styles.monitoringOverallPane}>
        <div
          className={styles.leftPanel}
          style={{
            width: isContinuous ? "100%" : undefined
          }}
        >
          <div
            style={{
              heigh: "45%",
              border: "1px solid #C8CAD4",
              borderRadius: "6px",
              margin: "10px"
            }}
          >
            {!isContinuous && optimized && this.renderTopSummary()}
            {isLoading ? this.renderLoadingPlaceholder() : this.renderMainPanel()}
          </div>
        </div>
        {!isContinuous && (
          <div className={styles.rightPanel}>
            <div className={styles.notificationPanel} style={numWarnings === 0 ? { paddingBottom: "10px" } : {}}>
              {numWarnings > 0 ? (
                <Accordion
                  header={
                    <React.Fragment>
                      <img src={NotificationBell} alt="notification bell" />
                      <div className={styles.notificationText}>{`${numWarnings} Performance Alerts`}</div>
                    </React.Fragment>
                  }
                >
                  {segmentWarnings &&
                    segmentWarnings.map((warning, i) => (
                      <AlertCard
                        key={"alert-" + i}
                        data={warning}
                        adjustAssumptions={adjustAssumptions}
                        timePeriod={timePeriod}
                        setupLabels={setupLabels}
                        hideAdjust
                      />
                    ))}
                  {retFairnessWarnings && (
                    <FairnessAlertCard
                      fairnessWarnings={retFairnessWarnings}
                      fairnessObjective={fairnessObjective}
                      fairnessToleranceBound={fairnessToleranceBound}
                      setupLabels={setupLabels}
                      hideAdjust
                    />
                  )}
                  {dataDriftWarnings && (
                    <DataDriftAlertCard
                      data={dataDriftWarnings}
                      adjustAssumptions={adjustAssumptions}
                      setupLabels={setupLabels}
                      hideAdjust
                    />
                  )}
                  {modelDriftWarnings && (
                    <DataDriftAlertCard
                      data={modelDriftWarnings}
                      adjustAssumptions={adjustAssumptions}
                      setupLabels={setupLabels}
                      hideAdjust
                    />
                  )}
                </Accordion>
              ) : (
                <React.Fragment>
                  <img src={NotificationBell} alt="notification bell" />
                  <div className={styles.notificationText}>{`${numWarnings} Performance Alerts`}</div>
                </React.Fragment>
              )}
            </div>
            {/* <div style={{ marginTop: "10px", display: "flex" }}>
              <ImpliedStrategy id={runId} expanded />
            </div> */}
            <div style={{ marginTop: "10px", display: "flex" }}>{this.renderMiniFunnel()}</div>
          </div>
        )}
      </div>
    );
  }
}
